import Navbar from "./Components/Navbar"
import './App.css';
import AllRoutes from "./Components/AllRoutes";
import HomePage from "./Pages/HomePage";
import Footer from "./Components/Footer";

function App() {
  return (
    <div className="App">
      <AllRoutes/>
    </div>
  );
}

export default App;
